// components/invoice/GridFooterSummary.jsx
import * as React from "react";
import { Box, Typography } from "@mui/material";
import { GridPagination } from "@mui/x-data-grid";

const formatGTQ = (value = 0) =>
  new Intl.NumberFormat("es-GT", { style: "currency", currency: "GTQ" }).format(value);

function GridFooterSummary({ totalFiltrado = 0, totalSeleccion = 0, count = 0 }) {
  return (
    <Box
      sx={{
        px: 2,
        py: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderTop: "1px solid",
        borderColor: "divider",
        bgcolor: "background.paper",
        gap: 2,
        flexWrap: "wrap",
      }}
    >
      {/* Resumen numérico a la izquierda */}
      <Box sx={{ display: "flex", gap: 4 }}>
        <Box>
          <Typography variant="caption" color="text.secondary">
            Total
          </Typography>
          <Typography variant="body2" fontWeight="bold">
            {formatGTQ(totalFiltrado)}
          </Typography>
        </Box>

        <Box>
          <Typography variant="caption" color="text.secondary">
            Total seleccionado
          </Typography>
          <Typography variant="body2" fontWeight="bold">
            {formatGTQ(totalSeleccion)}
          </Typography>
        </Box>

        <Box>
          <Typography variant="caption" color="text.secondary">
            Facturas
          </Typography>
          <Typography variant="body2" fontWeight="bold">
            {count}
          </Typography>
        </Box>
      </Box>

      {/* Paginación a la derecha */}
      <GridPagination />
    </Box>
  );
}

export default React.memo(GridFooterSummary);
